import React from 'react'
import { observer } from 'mobx-react-lite'

import { Info } from '@material-ui/icons'
import { createStyles, makeStyles, useTheme } from '@material-ui/core/styles'

import { MoySkladProductPriceDialog } from './PricesDialog'

import { useBoolState } from '../hooks/commonHooks'

import { MoySkladProductPriceModel } from '../server/mpsklad_core/Models/MoySkladProductPriceModel'

export type MoySkladProductPricesButtonProps = {
  prices: MoySkladProductPriceModel[]
}

export const MoySkladProductPricesButton =
  observer(({prices}: MoySkladProductPricesButtonProps) => {
    const classes = useStyles()
    const {palette} = useTheme()
    const [open, setOpen, setClose] = useBoolState()

    return <>
      <div
        title={'Цены'}
        className={classes.iconWrap}
        onClick={setOpen}
      >
        <Info
          fontSize="small"
          htmlColor={palette.mpSkladPrimary.blue}
        />
      </div>

      <MoySkladProductPriceDialog prices={prices} open={open} onClose={setClose}/>
    </>
  })

const useStyles =
  makeStyles(({spacing}) => createStyles({
    iconWrap: {
      marginLeft: spacing(0.5),
      marginRight: spacing(0.5),
      display: 'inline-flex',
      cursor: 'pointer'
    }
  }))